<template>
    <PageComponent 
        :loader="loader" @showLoader="showLoader" @hideLoader="hideLoader"
        :addButtonLabel="addButtonLabel"
        @handleAddNew="addNewBranch"
        :showAddButton=false
        :searchFilters="searchFilters"
        @searchPage="searchActivities"
        @resetFilters="resetFilters"
        :addingRight="addingRight"
        :rightsModule="rightsModule"
        :columns="tableColumns"
        :rows="depList"
        :actions="actions"
        :showActions=false
        :idField="idField"
        @handleActionClick="handleActionClick"
        :count="depCount"
        :currentPage="currentPage"
        :result="depArrLen"
        @loadPrev="loadPrev"
        @loadNext="loadNext"
        @firstPage="firstPage"
        @lastPage="lastPage"
        :showNextBtn="showNextBtn"
        :showPreviousBtn="showPreviousBtn"
        :selectedValue="selectedValue"
        @selectSearchQuantity="selectSearchQuantity"
    />
    <MovableModal v-model:visible="depModalVisible" :title="title" :modal_top="modal_top" :modal_left="modal_left" :modal_width="modal_width"
        :loader="modal_loader" @showLoader="showModalLoader" @hideLoader="hideModalLoader" >
        <DynamicForm 
            :fields="formFields" :flex_basis="flex_basis" :flex_basis_percentage="flex_basis_percentage" 
            :displayButtons="displayButtons" @handleSubmit="saveBranch" @handleReset="handleReset"
        />
    </MovableModal>
</template>

<script>
import axios from "axios";
import { ref, computed, watch, onMounted, onBeforeMount } from 'vue';
import PageComponent from '@/components/PageComponent.vue'
import MovableModal from '@/components/MovableModal.vue'
import DynamicForm from '../NewDynamicForm.vue';
import { useStore } from "vuex";
import { useToast } from "vue-toastification";

export default{
    name: 'User_Activities',
    components:{
        PageComponent,MovableModal,DynamicForm
    },
    setup(){
        const store = useStore();
        const toast = useToast();
        const loader = ref('');
        const modal_loader = ref('none');
        const title = ref('Branch Details');
        const addButtonLabel = ref('New Branch');
        const addingRight = ref('Add Company Department');
        const rightsModule = ref('Settings');
        const idField = 'user_activity_id';
        const depModalVisible = ref(false);
        const userComponentKey  = ref(0);
        const depList = ref([]);
        const depResults = ref([]);
        const depArrLen = ref(0);
        const depCount = ref(0);
        const pageCount = ref(0);
        const currentPage = ref(1);
        const selectedValue = ref(50);
        const showNextBtn = ref(false);
        const showPreviousBtn = ref(false);
        const flex_basis = ref('');
        const flex_basis_percentage = ref('');
        const displayButtons = ref(true);
        const errors = ref([]);
        const modal_top = ref('200px');
        const modal_left = ref('400px');
        const modal_width = ref('30vw');
        const isEditing = computed(()=> store.state.Branches.isEditing)
        const selectedBranch = computed(()=> store.state.Branches.selectedBranch);
        const tableColumns = ref([
            {type: "checkbox"},
            {label: "Date", key: "date"},
            {label: "User", key: "username"},
            {label: "Email", key: "email"},
            {label: "Type", key: "activity_type", txtColor: "txtColor"},
            {label: "Description", key: "description"},
        ])
        const actions = ref([
            {name: 'delete', icon: 'fa fa-trash', title: 'Delete Session', rightName: 'Delete Company Department'},
        ])
        const companyID = computed(()=> store.state.userData.company_id);
        const usersArray = computed(() => store.state.userData.userArr);
        const userID = ref('');
        const date_from_search = ref('');
        const date_to_search = ref('');
        const activity_type_search = ref('');
        const description_search = ref('');
        const fetchUsers = async() =>{
            await store.dispatch('userData/fetchUsers', {company:companyID.value});
        };
        const handleSelectedUser = async(option) =>{
            await store.dispatch('userData/handleSelectedUser', option)
            userID.value = store.state.userData.userID;

        };
        const clearSelectedUser = async() =>{
            await store.dispatch('userData/updateState', {userID: ''});
            userID.value = store.state.userData.userID;
        };
        const searchFilters = ref([
            {  
                type:'search-dropdown', value: userID.value, componentKey: userComponentKey,
                selectOptions: usersArray, optionSelected: handleSelectedUser,
                searchPlaceholder: 'Select User...', dropdownWidth: '350px',
                clearSearch: clearSelectedUser
            },
            {type:'date', placeholder:"From Date...", value: date_from_search, width:32,},
            {type:'date', placeholder:"To Date...", value: date_to_search, width:32,},     
            {
                type:'dropdown', placeholder:"Activity Type..", value: activity_type_search, width:32,
                options: [{text:'Creating',value:'Creating'},{text:'Editing',value:'Editing'},{text:'Approving',value:'Approving'},{text:'Deleting',value:'Deleting'}]
            },
            {type:'text', placeholder:"Description...", value: description_search, width:64},
        ]);
        const formFields = ref([]);
        const updateFormFields = (branch) => {
            formFields.value = [
                { type: 'text', name: 'name',label: "Name", value: branch?.name || '', required: true },
                { type: 'text', name: 'email',label: "Email", value: branch?.email || '', required: false },
                { type: 'text', name: 'phone_number',label: "Phone Number", value: branch?.phone_number || '', required: false },
                { type: 'text', name: 'town',label: "Town", value: branch?.town || '', required: false },
                { type: 'text', name: 'country',label: "Country", value: branch?.country || '', required: false },
            ];
        };
        watch(selectedBranch, (newBranch) => {
            updateFormFields(newBranch);
        }, { immediate: true });
        const addNewBranch = () =>{
            depModalVisible.value = true;
            handleReset();
            store.dispatch("Branches/updateState",{isEditing:false})
            flex_basis.value = '1/2';
            flex_basis_percentage.value = '50';
        }
        const handleActionClick = async(rowIndex, action, row) =>{
            if( action == 'edit'){
                const depID = row[idField];
                let formData = {
                    company: companyID.value,
                    branch: depID
                }
                await store.dispatch('Branches/fetchBranch',formData).
                then(()=>{
                    depModalVisible.value = true;
                    flex_basis.value = '1/2';
                    flex_basis_percentage.value = '50';
                })
                
            }else if(action == 'delete'){
                const depID = [row[idField]];
                let formData = {
                    company: companyID.value,
                    branch: depID
                }
                await store.dispatch('Branches/deleteBranch',formData).
                then(()=>{
                    searchActivities();
                })
            }
        } 
        const handleReset = () =>{
            for(let i=0; i < formFields.value.length; i++){
                formFields.value[i].value = '';
            }
        }
        const showModalLoader = () =>{
            modal_loader.value = "block";
        }
        const hideModalLoader = () =>{
            modal_loader.value = "none";
        }
        const createBranch = async() =>{
            showModalLoader();
            let formData = {
                name: formFields.value[0].value,
                email: formFields.value[1].value,
                phone_number: formFields.value[2].value,
                town: formFields.value[3].value,
                country: formFields.value[4].value,
                company: companyID.value
            }
            errors.value = [];
            for(let i=0; i < formFields.value.length; i++){
                if(formFields.value[i].value =='' && formFields.value[i].required == true){
                    errors.value.push('Error');
                }
            }
            if(errors.value.length){
                toast.error('Fill In Required Fields');
                hideModalLoader();
            }else{
                try {
                    const response = await store.dispatch('Branches/createBranch', formData);
                    if(response && response.status === 201) {
                        hideModalLoader();
                        toast.success('Branch created successfully!');
                        handleReset();
                    }else {
                        toast.error('An error occurred while creating the Branch.');
                    }
                } catch (error) {
                    console.error(error.message);
                    toast.error('Failed to create Branch: ' + error.message);
                } finally {
                    hideModalLoader();
                    searchActivities();
                }
            }

        }
        const updateBranch = async() =>{
            showModalLoader();
            errors.value = [];
            let formData = {
                name: formFields.value[0].value,
                email: formFields.value[1].value,
                phone_number: formFields.value[2].value,
                town: formFields.value[3].value,
                country: formFields.value[4].value,
                company: companyID.value,
                branch: selectedBranch.value.branch_id
            }
            for(let i=0; i < formFields.value.length; i++){
                if(formFields.value[i].value =='' && formFields.value[i].required == true){
                    errors.value.push('Error');
                }
            }
            if(errors.value.length){
                    toast.error('Fill In Required Fields');
            }else{
                try {
                    const response = await store.dispatch('Branches/updateBranch', formData);
                    if (response && response.status === 200) {
                        hideModalLoader();
                        toast.success("Branch updated successfully!");
                        handleReset();
                    } else {
                        toast.error('An error occurred while updating the Branch.');
                    }
                } catch (error) {
                    console.error(error.message);
                    toast.error('Failed to update Branch: ' + error.message);
                } finally {
                    hideModalLoader();
                    searchActivities();
                }
            }
        }
        const saveBranch = () =>{
            if(isEditing.value == true){
                updateBranch();
            }else{
                createBranch();
            }
        }
        const showLoader = () =>{
            loader.value = "block";
        }
        const hideLoader = () =>{
            loader.value = "none";
        }
        const searchActivities = () =>{
            showLoader();
            showNextBtn.value = false;
            showPreviousBtn.value = false;
            let formData = {
                date_from: date_from_search.value,
                date_to: date_to_search.value,
                description: description_search.value,
                activity_type: activity_type_search.value,
                user: userID.value,
                page_size: selectedValue.value,
                company: companyID.value
            }
            axios
            .post(`api/v1/get-user-activity-logs/?page=${currentPage.value}`,formData)
            .then((response)=>{
                depList.value = response.data.results;
                depResults.value = response.data;
                depArrLen.value = depList.value.length;
                depCount.value = depResults.value.count;
                pageCount.value = Math.ceil(depCount.value / selectedValue.value);
                
                if(response.data.next){
                    showNextBtn.value = true;
                }
                if(response.data.previous){
                    showPreviousBtn.value = true;
                }
            })
            .catch((error)=>{
                console.log(error);
            })
            .finally(()=>{
                hideLoader();
            })
        }
        const loadPrev = () =>{
            if (currentPage.value <= 1){
                currentPage.value = 1;
            }else{
                currentPage.value -= 1;
            }
            
            searchActivities();
        }
        const loadNext = () =>{
            if(currentPage.value >= pageCount.value){
                currentPage.value = pageCount.value;
            }else if(currentPage.value < pageCount.value){
                currentPage.value += 1;
            }
            
            searchActivities();
        }
        const firstPage = ()=>{
            currentPage.value = 1;
            searchActivities();
        }
        const lastPage = () =>{
            currentPage.value = pageCount.value;
            searchActivities();
        }
        const selectSearchQuantity = (newValue) =>{
            selectedValue.value = newValue;
            searchActivities(selectedValue.value);
        };
        const resetFilters = () =>{
            date_from_search.value = '';
            date_to_search.value = '';
            description_search.value = "";
            activity_type_search.value = "";
            userComponentKey.value += 1;
            userID.value = '';
            currentPage.value = 1;
            searchActivities();
        }
        onMounted(()=>{
            searchActivities();
            fetchUsers();
        })
        return{
            title,idField, searchActivities, addButtonLabel, searchFilters, resetFilters, tableColumns, depList,
            depResults, depArrLen, depCount, pageCount, showNextBtn, showPreviousBtn,modal_top, modal_left, modal_width,
            loadPrev, loadNext, firstPage, lastPage, actions, formFields, depModalVisible, addNewBranch,
            displayButtons,flex_basis,flex_basis_percentage, handleActionClick, handleReset, saveBranch,selectSearchQuantity,selectedValue,
            showLoader, loader, hideLoader, modal_loader, showModalLoader, hideModalLoader,addingRight,rightsModule
        }
    }
}
</script>